var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"price"},[_vm._v(" R$ "+_vm._s(_vm.getPrice)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }